module.exports = __webpack_public_path__ + "img/98.a49c16b7.jpg";